import c from "../common";

export default {
  //Column
  Time: "時間",
  status: c.status.chn,
  redeemed: "已換領",
  currency: "貨幣",
  vendorName: c.vendor.chn + "名",
  assistant: c.assistant.chn,
  consumerName: c.consumer.chn + "名稱",
  consumerEmail: c.consumer.chn + "電郵",
  consumerTel: c.consumer.chn + "電話",
  totalAmount: "總金額(CAD)",
  totalQty: "兌換總數",
  qty: "張數",
  download: c.download.chn,

  voucherName: c.voucher.chn + "名稱",
  voucherId: c.voucher.chn + "編號",
  price: "金額(CAD)",

  staffId: c.assistant.chn,

  reducePoint: "扣減積分",
  //
  text1: "換領記錄",
  

};
